import { trackEvent } from "apps/web/src/reporting/reporting";
import type { RecipeAiFlow } from "apps/web/src/hooks/useRevisionGatedAiFlow";

export type RecipeAiFlowTrackingEntity = "Recipe" | "Menu item";

type RecipeAiFlowOpeners = {
  generate: () => void;
  photo: () => void;
  link: () => void;
};

/** Track and open the matching AI generate / transcribe modal. */
export const openTrackedRecipeAiFlow = (
  flow: RecipeAiFlow,
  entity: RecipeAiFlowTrackingEntity,
  openers: RecipeAiFlowOpeners
): void => {
  if (flow === "generate") {
    trackEvent(`Nutrition | Food Management | ${entity} | Enter AI Generate Flow`, {});
    openers.generate();
    return;
  }
  if (flow === "photo") {
    trackEvent(`Nutrition | Food Management | ${entity} | Enter AI Transcription Flow`, { type: "Photo" });
    openers.photo();
    return;
  }
  trackEvent(`Nutrition | Food Management | ${entity} | Enter AI Transcription Flow`, { type: "URL" });
  openers.link();
};
